import React from "react";
import { Spinner } from "react-rainbow-components";
import DashboardDasktopPage from "./DashboardDasktopPage";
import DashboardMobilePage from "./DashboardMobilePage";
import useDashboardPage from "./useDashboardPage";

export default function DashboardPage() {
  const {
    width,
    isLoadingBookings,
    bookings,
    getPet,
    setDataCard,
    isLoading,
    dataCard,
    handleChangeTage,
    handleSubmit,
  } = useDashboardPage();

  const props = {
    bookings: bookings,
    getPet: getPet,
    setDataCard: setDataCard,
    handleChangeTage: handleChangeTage,
    handleSubmit: handleSubmit,
    dataCard: dataCard,
    isLoading: isLoading || isLoadingBookings,
  };

  if (isLoading) return <Spinner />;

  if (width < 768)
    return !isLoadingBookings && <DashboardMobilePage {...props} />;
  else return !isLoadingBookings && <DashboardDasktopPage {...props} />;
}
